export default __webpack_public_path__ + "static/media/onboardingImage.82bfd23b.png";